import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';
import { Popup, TextArea, Button, Toast } from 'antd-mobile';
import { addEventDot } from '@/services/api';
import CONFIG from 'GlobalConfigFile';
import { _getPhoneModel, decodeToken } from '@/utils/utils';
import { getLoginToken } from '@/utils/localStorage';
import { getConsoleLogs } from '@/utils/consoleBuffer';

const DEFAULT_SERVER = process.env.DEFAULT_SERVER || CONFIG.Server;

const BugReportModal = ({ visible, onClose }) => {
  const [description, setDescription] = useState('');
  const [stepsToReproduce, setStepsToReproduce] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const patientStaffId = useSelector(state => state.baseInfo['patient']?.roleInfo?.staffId);
  const doctorStaffId = useSelector(state => state.baseInfo['doctor']?.roleInfo?.staffId);
  const adminStaffId = useSelector(state => state.baseInfo['admin']?.roleInfo?.staffId);

  useEffect(() => {
    if (visible) {
      setDescription('');
      setStepsToReproduce('');
    }
  }, [visible]);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const userId = patientStaffId || doctorStaffId || adminStaffId || 'anonymous';
      const role = patientStaffId ? 'patient' : doctorStaffId ? 'doctor' : adminStaffId ? 'admin' : null;
      const { tenantId } = role ? decodeToken(getLoginToken(role)) : {};

      const payload = {
        id: uuidv4(),
        source: 'browser',
        occurOn: moment().unix() * 1000,
        project: 'EAP',
        env: DEFAULT_SERVER,
        userId,
        deviceId: _getPhoneModel(),
        name: 'bug:report/manual',
        props: {
          eventName: '现场Bug上报',
          tenantId: tenantId || 'anonymous',
          description,
          stepsToReproduce,
          currentUrl: window.location.href,
          userAgent: navigator.userAgent,
          consoleLogs: getConsoleLogs(),
        },
      };

      await addEventDot(payload);
      Toast.show({ icon: 'success', content: '上报成功' });
    } catch (e) {
      Toast.show({ icon: 'fail', content: '上报失败' });
    } finally {
      setSubmitting(false);
      onClose();
    }
  };

  return (
    <Popup visible={visible} onMaskClick={onClose} bodyStyle={{ padding: '16px', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>上报Bug</div>
        <div>
          <div style={{ marginBottom: '4px', color: '#666' }}>问题描述</div>
          <TextArea
            placeholder="请描述遇到的问题"
            value={description}
            onChange={setDescription}
            rows={3}
          />
        </div>
        <div>
          <div style={{ marginBottom: '4px', color: '#666' }}>复现步骤</div>
          <TextArea
            placeholder="请描述复现步骤"
            value={stepsToReproduce}
            onChange={setStepsToReproduce}
            rows={3}
          />
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button style={{ flex: 1 }} onClick={onClose} disabled={submitting}>取消</Button>
          <Button style={{ flex: 1 }} color="primary" onClick={handleSubmit} loading={submitting}>提交</Button>
        </div>
      </div>
    </Popup>
  );
};

export default BugReportModal;
